var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6626 23.8166L33.0155 17.4438C32.7044 17.2718 32.3546 17.1816 31.9991 17.1816C31.6435 17.1816 31.2938 17.2718 30.9826 17.4438L19.3356 23.8192C19.0029 24.0012 18.7253 24.2692 18.5316 24.5951C18.3379 24.9211 18.2352 25.293 18.2344 25.6722V38.3304C18.2352 38.7096 18.3379 39.0815 18.5316 39.4075C18.7253 39.7334 19.0029 40.0014 19.3356 40.1833L30.9826 46.5588C31.2938 46.7307 31.6435 46.8209 31.9991 46.8209C32.3546 46.8209 32.7044 46.7307 33.0155 46.5588L44.6626 40.1833C44.9952 40.0014 45.2729 39.7334 45.4666 39.4075C45.6603 39.0815 45.7629 38.7096 45.7638 38.3304V25.6735C45.7636 25.2937 45.6613 24.9209 45.4676 24.5942C45.2739 24.2675 44.9958 23.9989 44.6626 23.8166ZM31.9991 19.2967L42.6336 25.1203L38.6922 27.2763L28.0576 21.4528L31.9991 19.2967ZM31.9991 30.9438L21.3645 25.1203L25.8526 22.6625L36.4872 28.486L31.9991 30.9438ZM43.6461 38.3357L33.0579 44.1314V32.7742L37.2932 30.4567V35.1791C37.2932 35.4599 37.4048 35.7292 37.6033 35.9278C37.8019 36.1263 38.0712 36.2379 38.352 36.2379C38.6328 36.2379 38.9022 36.1263 39.1007 35.9278C39.2993 35.7292 39.4108 35.4599 39.4108 35.1791V29.2973L43.6461 26.9798V38.3304V38.3357Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCardIcon);
export default __webpack_public_path__ + "static/media/serviceCardIcon.a8dae436ca983aa7b99a45148ea9ff9f.svg";
export { ForwardRef as ReactComponent };